import React from "react"
import Layout from "./src/components/layout"
import {Amplify} from "aws-amplify"
import awsConfig from "./src/aws-exports"
import {ApolloClient, ApolloLink, ApolloProvider, InMemoryCache} from "@apollo/client"
import {AUTH_TYPE, createAuthLink} from "aws-appsync-auth-link"
import {createSubscriptionHandshakeLink} from "aws-appsync-subscription-link"
import {Auth} from "@aws-amplify/auth"
import {Root} from "./src/components/Root";

import "./src/styles.scss";
import ProtectedPage from './src/components/Protected/protected'

const Graphql = ({ children }) => {

  Amplify.configure(awsConfig)

  const url = awsConfig.aws_appsync_graphqlEndpoint
  const region = awsConfig.aws_appsync_region

  const token = () =>
    Auth.currentSession().then(session => session.getIdToken().getJwtToken()).catch(() => undefined)

  const link = ApolloLink.from([
    createAuthLink({
      url, region, auth: {
        type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        jwtToken: token()
      }
    }),
    createSubscriptionHandshakeLink({
      url, region, auth: {
        type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        jwtToken: token()
      }
    })
  ])

  const client = new ApolloClient({
    link,
    cache: new InMemoryCache()
  })

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export const wrapPageElement = ({element, props}) =>
    <ProtectedPage><Graphql><Root><Layout {...props}>{element}</Layout></Root></Graphql></ProtectedPage>





